import { render, staticRenderFns } from "./salary_history.vue?vue&type=template&id=6961e802"
import script from "./salary_history.vue?vue&type=script&lang=js"
export * from "./salary_history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports